import Tab, { TabGroup, type TabProps } from './tab';
import SquareTab, { SquareTabGroup } from './square-tab';
import DocTab from './doc-tab';

export { SquareTab, SquareTabGroup, DocTab, TabGroup };
export type { TabProps };
export default Tab;
